<app-login-layout header="Password reset">
  @if (error()) {
    <div class="alert alert-danger col-10 mt-4" role="alert" data-cy="alert">
      <div class="alert-message"><b class="pe-1">There's been an issue: </b>{{ error() }}</div>
    </div>
  }

  <app-pass-form (send)="onSend($event)" [isSending]="isSending()" [isReset]="true" />

  <a routerLink="/login" class="mt-4 d-block forgot-password-link" data-cy="forgotPassword">Back to login</a>
</app-login-layout>
